import { AxiosInstance } from 'axios';
import resultRepository from '@/repository/manager/whereaboutsCheck/resultRepository';
import resultCache from '@/repository/manager/whereaboutsCheck/resultCache';
import { localStorageCache } from '@/repository/manager/whereaboutsCheck/cache';

export { default as whereaboutsCheckStatusRepository } from './statusRepository';

export const whereaboutsCheckResultRepository = (axios: AxiosInstance) => {
  return resultRepository(axios, resultCache(localStorageCache));
};
